import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import SwipeableViews from "react-swipeable-views";
import AppBar from "material-ui/AppBar";
import Tabs, { Tab } from "material-ui/Tabs";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Card, { CardContent, CardMedia } from "material-ui/Card";
import KeyboardArrowLeft from "material-ui-icons/KeyboardArrowLeft";
import KeyboardArrowRight from "material-ui-icons/KeyboardArrowRight";

const styles = (theme) => ({
  pageCarte: {
    maxWidth: "100%",
    margin: "0 auto",
    display: "block",
    zIndex: "20",
  },
  customAppBar: {
    zIndex: "30",
    position: "relative",
  },
  content: {
    display: "flex",
    alignItems: "baseline",
  },
  customButton: {
    paddingLeft: "0px",
    paddingRight: "0px",
    minWidth: "50px",
  },
  count: {
    display: "inline-block",
    marginRight: "1rem",
  },
});

const TabContainer = ({ children, dir }) => {
  return <div>{children}</div>;
};

class Carte extends Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };

  previousPage() {
    const index = this.state.value;

    if (index > 0) {
      this.setState({ value: index - 1 });
    }
  }

  nextPage() {
    const index = this.state.value;

    if (index < 4) {
      this.setState({ value: index + 1 });
    }
  }

  render() {
    const { classes, theme } = this.props;
    const { value } = this.state;

    return (
      <Grid style={{ marginBottom: "16px" }} item xs={12} md={8}>
        <Card className={classes.card}>
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="title" style={{ flex: "1 1 0%" }}>
                La carte
              </Typography>
              <div className={classes.controls}>
                {/* <span className={classes.count}>
                  Page <b>{value + 1}</b> / <b>12</b>
                </span> */}
                <Button
                  className={classes.customButton}
                  size="small"
                  onClick={this.previousPage.bind(this)}
                  disabled={value == 0}
                >
                  <KeyboardArrowLeft color="primary" />
                </Button>
                <Button
                  className={classes.customButton}
                  size="small"
                  onClick={this.nextPage.bind(this)}
                  disabled={value == 4}
                >
                  <KeyboardArrowRight color="primary" />
                </Button>
              </div>
            </CardContent>
          </div>
          <CardMedia>
            <AppBar
              position="static"
              className={classes.customAppBar}
              color="default"
            >
              <Tabs
                value={this.state.value}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                fullWidth
              >
                <Tab label="Starters & Sides" />
                <Tab label="Mains" />
                <Tab label="Machiso Set" />
                <Tab label="Drinks" />
                <Tab label="Desserts & Digestifs" />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={this.state.value}
              onChangeIndex={this.handleChangeIndex}
            >
              <TabContainer dir={theme.direction}>
                <img
                  className={classes.pageCarte}
                  src="/images/carte/page_1.jpg"
                />
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <img
                  className={classes.pageCarte}
                  src="/images/carte/page_2.jpg"
                />
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <img
                  className={classes.pageCarte}
                  src="/images/carte/page_3.jpg"
                />
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <img
                  className={classes.pageCarte}
                  src="/images/carte/page_4.jpg"
                />
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <img
                  className={classes.pageCarte}
                  src="/images/carte/page_5.jpg"
                />
              </TabContainer>
            </SwipeableViews>
          </CardMedia>
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Carte);



// WEBPACK FOOTER //
// ./src/components/Carte/Carte.js